import React, { useEffect } from "react";
import styles from "./style.module.css";

// -- Lib
import { classNames } from "../../../lib/helpers";
import { BLUE } from "../../../lib/constants";

// -- Hooks
import useLanguage from "../../../hooks/use_language";
import { useHistory } from "react-router-dom";

// -- Components
import useStoreon from "storeon/react";
import DashboardNumber from "../DashboardNumber";
import DashboardFigure from "../DashboardFigure";
import SingleItem from "../../../components/SingleItem";
import TrendingTerms from "../../../components/TrendingTerms";

const IndexView = (props = {}) => {
  const {
    deepdives = {},
    allDeepDives = [],
    entriesTotal = {},
    searchStats = [],
    events = [],
  } = props;

  // -- State
  const { dispatch } = useStoreon("tags", "statusHistory");

  useEffect(() => {
    dispatch("relationships/fetch");
  }, []);

  const i18n = useLanguage();

  // -- Deepdives rendered
  const deepDiveTeasers = allDeepDives.slice(0, 3).map((teaser) => {
    teaser["value"] = teaser["body"];
    delete teaser.date;
    return (
      <SingleItem data={teaser} className={styles.singleItem} key={teaser.id} />
    );
  });

  let eventElements = <></>;
  if (events.length) {
    eventElements = events
      .map((event) => {
        return {
          date: new Date(event.date + "T00:00:00-05:00"), 
          link: event.url,
          value: event.title,
        };
      })
      .filter((item) => item.date >= Date.now())
      .sort((a, b) => a.date - b.date)
      .slice(0, 5)
      .map((item, i) => (
        <SingleItem data={item} className={styles.singleItem} key={i} />
      ));
  }

  const history = useHistory();

  const goToSearchTerm = (term) => {
    history.push(`/search?terms=${term}`);
  };

  return (
    <div className={classNames("constrain", "grid")}>
      <div className={classNames("grid--item__third", styles.column)}>
        <h2 className={styles.subhead}>
          {i18n("dashboard", "trending_terms")}
        </h2>
        <TrendingTerms onSelect={goToSearchTerm} />
        <br />
        <br />
        <br />
        <h2 className={styles.subhead}>
          {i18n("dashboard", "search_subhead")}
        </h2>
        {entriesTotal.pending || (
          <DashboardFigure
            className={styles.bigFigure}
            figure={<DashboardNumber number={entriesTotal.data} big />}
            variants={["big"]}
          >
            {i18n("dashboard", "current_searchable")}
          </DashboardFigure>
        )}
        {searchStats.map(({ name = "", count = "", id = "" }) => {
          return (
            <DashboardFigure
              key={name}
              figure={<DashboardNumber number={count} />}
              to={`/search?country=${id}`}
            >
              {i18n("countries", id.toLowerCase()) || name}
            </DashboardFigure>
          );
        })}
      </div>
      <div className={classNames("grid--item__third", styles.column)}>
        <h2 className={styles.subhead}>
          {i18n("dashboard", "deepdives_subhead")}
        </h2>
        {deepdives.pending || (
          <DashboardFigure
            className={styles.bigFigure}
            figure={
              <DashboardNumber
                number={allDeepDives.length}
                big
                shadow
                bg={BLUE}
              />
            }
          >
            {i18n("dashboard", "recent_deepdives")}
          </DashboardFigure>
        )}
        {deepDiveTeasers}
      </div>
      <div className={classNames("grid--item__third", styles.column)}>
        <h2 className={styles.subhead}>
          {i18n("dashboard", "events") || "Upcoming Events"}
        </h2>
        {eventElements}
      </div>
    </div>
  );
};

export default IndexView;
